module.exports = __webpack_public_path__ + "static/Joystream_Thumbnail_6-2d9413c01485db9a2a56371415c40d86.jpeg";